/**
 * 微信相关常量定义
 */

/**
 * 微信URL参数列表
 * 这些参数会在初始化时被清理，避免签名不一致
 */
export const WECHAT_URL_PARAMS = [
  'from',
  'isappinstalled',
  'scene',
  'clicktime',
  'enterid',
  'ascene',
  'devicetype',
  'version',
  'lang',
  'nettype',
  'abtest_cookie',
  'pass_ticket',
  'wx_header'
]

/**
 * 微信录音相关JS-SDK API列表
 */
export const WECHAT_RECORD_API_LIST = [
  'startRecord',      // 开始录音
  'stopRecord',       // 停止录音
  'onVoiceRecordEnd', // 录音自动停止
  'playVoice',        // 播放语音
  'stopVoice',        // 停止播放
  'onVoicePlayEnd',   // 播放结束
  'uploadVoice'       // 上传语音
]

/**
 * 微信SDK初始化超时时间（毫秒）
 */
export const WECHAT_INIT_TIMEOUT = 10000

/**
 * 日志emoji图标
 */
export const LOG_ICONS = {
  START: '🔧',
  SUCCESS: '✅',
  ERROR: '❌',
  WARNING: '⚠️',
  INFO: 'ℹ️',
  CLEAN: '🧹',
  LINK: '🔗',
  PHONE: '📱',
  LOADING: '⏳',
  RED_DOT: '🔴'
}

